var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH8ServicesItemShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 114,
    viewBox: "0 0 110 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5896 -0.443636L39.6185 -0.607957L60.0776 19.2789L66.9196 25.9231L148.002 104.737L141.566 111.317L60.4838 32.5026L53.6417 25.8518L26.5896 -0.443636Z",
    fill: "#EBEEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00010541 -0.10843L47.3561 45.9233L60.4838 32.5024L93.5363 -1.28812L80.0219 -1.11767L73.3563 5.69683L66.9205 12.2764L60.0709 19.2789L53.6351 25.8584L47.1796 32.4581L13.5077 -0.272157L-2.17511e-05 -0.101796L-0.00010541 -0.10843Z",
    fill: "#EBEEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9271 12.2765L53.492 -0.782891L66.5209 -0.947212L73.3562 5.69702L80.1984 12.3478L151.037 81.2056L144.601 87.7785L73.7626 18.9273L66.9271 12.2765Z",
    fill: "#DEE3EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.202,
    height: 150,
    fill: "white",
    transform: "translate(1.42749 113.084) rotate(-90.7226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH8ServicesItemShape);
export default __webpack_public_path__ + "static/media/h8_services_item_shape.01604ae944f5d0833eaccd6d5501a2cc.svg";
export { ForwardRef as ReactComponent };